import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import { HeroImage } from "../shared/hero-image";
import styles from "../text-story-page/styles.m.css";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";

import stylesPhoto from "./styles.m.css";

function PhotoStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const renderHeaderPhoto = () => (
    <HeroImage story={props.story} className={stylesPhoto["hero-image"]} icon="album" headline="Photo Story" />
  );

  const storyHeadline = get(props, ["story", "subheadline"], () => null);

  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;

  return (
    <div className="page-content">
      <div className={`container`}>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={`${styles["main-content"]} ${stylesPhoto["main-content"]}`}>
          <article className={`${styles["story-body"]} js-story`}>
            {renderHeaderCard({ className: stylesPhoto["story-header"] })}
            {renderHeaderPhoto()}
            {!readMore && renderSocialMedia()}
            <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
            {cards &&
              cards.map((card, index) => {
                return (
                  <React.Fragment key={card.id}>
                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      story={props.story}
                      className="ad_300_250"
                    />

                    {index === 1 && (
                      <div>
                        <StoryMidPromotion story={props.story} />
                      </div>
                    )}

                    <StoryCard card={card} story={props.story} showCard={readMore} />
                  </React.Fragment>
                );
              })}

            <div id="we-story-end" />
            {renderFooter(readMore)}
          </article>
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
PhotoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { PhotoStory };
